module.exports = __webpack_public_path__ + "img/lander-action-01-wide.cbc8a53e.webp";